import { Helmet } from "react-helmet";

export const SEOHelmet = ({
  title = "ICL Software Solutions – Enterprise Software, Cloud & AI",
  description = "ICL Software Solutions delivers enterprise software, cloud platforms, AI chatbots, and compliance tools for importers, exporters, logistics providers, and maritime businesses.",
  url = "https://eximon.com",
  image = "https://eximon.com/img/apple-touch-icon.png",
}) => {
  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      <title>{title}</title>

      <meta charSet="utf-8" />
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};